(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["otapix-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var link = event.target.closest('a.otapix-whatsapp, a.otx-banpro__cta');
    if (!link || typeof window.gtag !== 'function') return;
    window.gtag('event', 'whatsapp_click', {
      send_to: 'G-8MYH8MHFJR',
      link_domain: 'wa.me',
      link_url: link.href,
      contact_channel: 'WhatsApp'
    });
  });
  } catch(e) { console.error(e); }
})();

})();
